import React from 'react';
import ScanLeadButton from '../../../EventHomeScreen/common/LeadScan/ScanLeadButton';

function LeadsFooter(props) {
    const {event} = props;

    return (
        <div className={['content'].join(' ')}>
            <ScanLeadButton event={event} />
        </div>
    );
}

export default LeadsFooter;
